import { SVGProps, Ref, forwardRef } from 'react';

export const GhostOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.01 5.466c.205-.246.527-.4.988-.4.462 0 .784.154.988.4.202.242.279.56.279.866s-.077.623-.279.865c-.204.246-.526.4-.988.4s-.783-.154-.988-.4c-.202-.242-.278-.559-.278-.865 0-.307.076-.624.278-.866"
                fill="currentColor"
            />
            <path
                d="M9.01 5.466c.204-.246.526-.4.987-.4.462 0 .784.154.989.4.201.242.278.56.278.866s-.077.623-.278.865c-.205.246-.527.4-.989.4s-.783-.154-.988-.4c-.202-.242-.278-.559-.278-.865 0-.307.076-.624.278-.866"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m14.998 14.067-.38-7.431C14.42 3.016 11.852.46 8 .5 4.15.46 1.58 3.015 1.383 6.636l-.381 7.43c-.056 1.092 1.181 1.8 2.154 1.234l1.247-.725a1.47 1.47 0 0 1 1.502.018l.947.581c.7.43 1.596.43 2.297 0l.946-.581a1.47 1.47 0 0 1 1.502-.018l1.247.725c.973.566 2.21-.142 2.154-1.233M7.985 1.9h.03c1.603-.016 2.845.502 3.702 1.312.86.813 1.42 2.006 1.502 3.498v.002l.379 7.384-.02.004-.01-.001-.02-.009-1.247-.725a2.87 2.87 0 0 0-2.939.035l-.946.582a.8.8 0 0 1-.831 0l-.948-.582a2.87 2.87 0 0 0-2.938-.035l-1.247.725-.02.009h-.01l-.02-.003.379-7.384V6.71c.082-1.492.643-2.685 1.502-3.498.857-.81 2.1-1.329 3.702-1.312"
                fill="currentColor"
            />
        </g>
    </svg>
));
GhostOutlinedSize16Glyph.displayName = 'GhostOutlinedSize16Glyph';
